import React, { useEffect, useCallback, useState} from 'react';
import {newSpore} from 'nft/spore.js';
import AudioPlayer from './AudioPlayer.js';
import BackendQuery from "decentralized/BackendQuery.js";
import {connect} from 'react-redux';
import {getLatestSpore} from './getSpores.js';
import UnknownProgressBar from "components/progressbar/UnknownProgressBar.js";

const SimplePlayer = ({selected, tokenId, spore, setShowStemPlayer}) => { 
    let [playing, setPlaying] = useState(false);
    let [latestSpore, setLatestSpore] = useState(undefined);

    useEffect(() => {
        setLatestSpore(undefined);
        getLatestSpore(selected, tokenId).then((spore) => {
            setLatestSpore(spore);
        });
    }, [setLatestSpore, tokenId, selected]);

    const makeASpore = () => {
        newSpore("QmZ2QDquVcE9KVZFCqJRDWfzdgzp3E4T2PutPnCYpkRu64", 0).then(x => {
            console.log("spore made=", x);
        });
    };

    return (
        <div className="simple-player">
          {latestSpore === null ? <div
                                    onClick={makeASpore}
                                    className="no-spores">No spores have been made yet.</div> : !latestSpore ? <UnknownProgressBar intervalTime={100} intervalPiece={3} text={selected ? "Loading Spore #" + selected.sporeId : "Loading Latest Spore"}/>
           : <AudioPlayer creator={latestSpore.creator} audioUnit={latestSpore.audioUnit}/>}
        {!selected && <div
            onClick={() => setShowStemPlayer(true)}
            className="pushable stem-player-button">
            Expand Player
                      </div>}
          {selected &&
           <div className="stem-player-button mint-spore">
             Mint Spore
             <div className="spore-tooltip">
               to mint, you must own a spore player
             </div>
           </div>}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SimplePlayer);
